import React from 'react';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import { ConfigProvider, message } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { apiErrorMessage } from '../shared/lib/apiError';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
  // Универсальный вывод ошибок мутаций: показываем сообщение,
  // пришедшее с сервера (NestJS `message`), а не абстрактное «Ошибка».
  // Можно отключить для конкретной мутации через `meta: { silentError: true }`.
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.meta?.silentError) return;
      message.error(apiErrorMessage(error) ?? 'Ошибка');
    },
  }),
});

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={ruRU}>
        {children}
      </ConfigProvider>
    </QueryClientProvider>
  );
}
